<div class="full-viewport-container">    
    <span>Bem vindo ao Cycle Connect.</span> <br>
    <span>O futuro do ciclismo indoor começa aqui.</span>
</div>
